import { render, staticRenderFns } from "./SelectVideoServiceModal.vue?vue&type=template&id=440b90d6&"
import script from "./SelectVideoServiceModal.vue?vue&type=script&lang=js&"
export * from "./SelectVideoServiceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports